import React from 'react';

import { Link } from 'react-router-dom'
import { useEffect } from 'react';
import { NavLink } from "react-router-dom";
import logoLarge from '../imgs/logoLarge.png';
import './mainpage.css';
import fencingCampImage from '../imgs/groupPhoto23.png';
import tbtLogo from '../imgs/tbtLogo.png';


export default function MainPage() {

	useEffect(() => {
		document.title = "RedPanda Fencing"
        window.scrollTo(0,0);
	}, []);


	return <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">

        {/* Hero Section */}
        <section className="text-center mb-8">
            <div className="mb-4">
                <img src={logoLarge} className="mx-auto w-5/12 max-w-md" alt="largeLogo" />
            </div>

            <div className="bg-tbtred rounded-2xl p-6 max-w-4xl mx-auto shadow-lg"> 
                <h1 className="text-white text-2xl md:text-3xl font-bold mb-3">An Organization of Fencers, for Fencers.</h1> 
                <h2 className="text-white text-lg md:text-xl font-semibold">A registered 501(c)(3) nonprofit dedicated to serving fencers in New Jersey and beyond.</h2>  
            </div> 
        </section> 
    
        {/* About Section */}
        <section className="mb-8 max-w-4xl mx-auto">
            <div className="bg-white border-4 border-gray-300 rounded-3xl p-6 shadow-md">
                <h1 className="text-3xl md:text-4xl text-center font-bold mb-4">Who are we?</h1>
                <p className="text-center text-lg md:text-xl leading-relaxed"> 
                    Red Panda Fencing Inc. is a 501(c)(3) nonprofit organization dedicated to providing education and instruction in the Olympic sport of fencing and to provide scholarship monies to individuals participating in post-high school technology-based programs.
                </p> 
            </div>
        </section> 

        {/* Projects Section */}
        <section id="projects" className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-8 max-w-7xl mx-auto"> 

            {/* Fencing Camp Card */}
            <div id="FencingCamp" className="bg-white border-2 border-gray-200 rounded-3xl p-6 md:p-8 shadow-lg"> 
                <h2 className="text-3xl md:text-4xl text-center font-extrabold mb-4">Red Panda Fencing Camp</h2> 

                <div className="mb-4">
                    <img src={fencingCampImage} className="mx-auto w-full rounded-xl border-4 border-tbtred object-cover" alt="FencingCampImage" />
                </div>

                <div className="text-center mb-4">
                    <p className="text-xl md:text-2xl font-bold mb-2">Camp registration closes June 30, 2026</p>
                    <NavLink 
                        to="https://forms.gle/pSKcAvA1eaeNv1dF7" 
                        className="inline-block text-xl text-tbtred underline hover:text-red-700 transition-colors" 
                        target="_blank"
                    >
                        Click here to quick register
                    </NavLink> 
                </div>
				
                <div className="bg-tbtred text-white rounded-3xl p-4 mb-4 border-2 border-white"> 
                    <h3 className="text-center text-lg md:text-xl font-semibold">
                        Three discipline fencing intensive camp led by high-level college and high school coaches from the tri-state area and beyond.
                    </h3>
                </div>
						
                <div className="text-center">  
                    <NavLink 
                        to="/fencingcamp" 
                        className="inline-block px-8 py-3 text-2xl md:text-3xl text-center border-2 border-tbtred rounded-xl hover:bg-tbtred hover:text-white transition-all duration-200 font-semibold"
                    >
                        Learn more!
                    </NavLink>  
                </div> 
            </div>

            {/* TBT Fencing App Card */}
            <div id="TbT Fencing App" className="bg-white border-2 border-gray-200 rounded-3xl p-6 md:p-8 shadow-lg"> 
                <h2 className="text-3xl md:text-4xl text-center font-extrabold mb-4">TBT Fencing App</h2> 

                <div className="mb-4 flex justify-center">
                    <img src={tbtLogo} className="w-64 h-64 border-4 rounded-xl border-tbtred p-2 bg-white" alt="TbtLogoImage" />
                </div>

                <div className="text-center mb-4"> 
                    <NavLink 
                        to="https://tbtfencing.com" 
                        className="inline-block text-xl text-tbtred underline hover:text-red-700 transition-colors" 
                        target="_blank"
                    >
                        Click here to go to the app website
                    </NavLink> 
                </div> 
				
                <div className="bg-tbtred text-white rounded-3xl p-4 mb-4 border-2 border-white"> 
                    <h3 className="text-center text-lg md:text-xl font-semibold">
                        A state of the art mobile and web-based application used for scoring and recording high school and college fencing dual meets and events
                    </h3>
                </div>

                <div className="text-center">  
                    <NavLink 
                        to="/tbt" 
                        className="inline-block px-8 py-3 text-2xl md:text-3xl text-center border-2 border-tbtred rounded-xl hover:bg-tbtred hover:text-white transition-all duration-200 font-semibold"
                    >
                        Learn more!
                    </NavLink>  
                </div> 
            </div>

        </section>

    </div>
}
